const getThemeMode = () => {
  return localStorage.getItem('tomedes_theme_mode') || 'light';
};

export default getThemeMode;
